import { render, staticRenderFns } from "./DealNotes.vue?vue&type=template&id=5244e8ca&scoped=true"
import script from "./DealNotes.vue?vue&type=script&lang=js"
export * from "./DealNotes.vue?vue&type=script&lang=js"
import style0 from "./DealNotes.vue?vue&type=style&index=0&id=5244e8ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5244e8ca",
  null
  
)

export default component.exports